module.exports = __webpack_public_path__ + "img/img_text_2.0dffc4eb.png";